import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { ConfigFormLabel } from './ConfigFormComponents';
import LogoPreview from './LogoPreview';
import './LogoUrlField.css';

/** Default logo object key in the public logos S3 bucket. */
export const DEFAULT_LOGO_FILE = 'rx_advocate.png';

/**
 * Logo file-name field with preview and one-click default.
 */
const LogoUrlField = ({
  value = '',
  onChange,
  onBlur,
  name = 'logoUrl',
  id = 'logo-url',
  disabled = false,
  sensitiveFields = [],
  helperText = 'Logo file name in the public S3 logos bucket',
  required = false,
  isInvalid = false,
  error,
}) => {
  const current = value || '';
  const trimmed = current.trim();
  const isDefault = trimmed === DEFAULT_LOGO_FILE;
  const showUseDefault = !disabled && !isDefault;

  const applyDefault = () => {
    onChange?.({
      target: { name, value: DEFAULT_LOGO_FILE },
    });
  };

  return (
    <Form.Group>
      <ConfigFormLabel
        label={
          required ? (
            <>
              Logo URL <span className="text-danger">*</span>
            </>
          ) : (
            'Logo URL'
          )
        }
        fieldName={name}
        sensitiveFields={sensitiveFields}
        htmlFor={id}
      />
      <div className="logo-url-field__row">
        <Form.Control
          id={id}
          type="text"
          name={name}
          value={current}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={DEFAULT_LOGO_FILE}
          disabled={disabled}
          isInvalid={isInvalid}
        />
        {showUseDefault && (
          <Button
            type="button"
            variant="outline-secondary"
            size="sm"
            className="logo-url-field__default-btn"
            onClick={applyDefault}
          >
            Use default
          </Button>
        )}
      </div>
      {isInvalid && error && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
      {isDefault ? (
        <p className="logo-url-field__hint text-muted">Using the RxAdvocate default logo</p>
      ) : (
        helperText && <p className="logo-url-field__hint text-muted">{helperText}</p>
      )}
      <LogoPreview logoKey={trimmed} />
    </Form.Group>
  );
};

export default LogoUrlField;
